import React from "react";
import "./Loader.css";

const Loader = () => {
  return <div id="loading-spinner"></div>;
};

export default Loader;